/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
var DESK_UPSELL_SWATCH_GROUPS =
  ".upsell_cart__types, .upsell_cart__variants, .upsell_mobile_cart__types, .upsell_mobile_cart__variants";
var DESK_UPSELL_SWATCHES =
  ".upsell_cart__types > .variant, .upsell_cart__variants > .variant, .upsell_mobile_cart__types > .variant, .upsell_mobile_cart__variants > .variant";

function deskUpsellShownSwatches($group) {
  return $group.children(".variant").filter(function () {
    return this.style.display !== "none";
  });
}

function deskUpsellSwatchesSync() {
  $(DESK_UPSELL_SWATCH_GROUPS).each(function () {
    var $group = $(this);
    $group.children(".variant").each(function () {
      this.setAttribute("aria-checked", $(this).hasClass("active") ? "true" : "false");
      this.setAttribute("tabindex", "-1");
    });
    var $shown = deskUpsellShownSwatches($group);
    var $current = $shown.filter(".active").first();
    ($current.length ? $current : $shown.first()).attr("tabindex", "0");
  });
}

function deskUpsellSwatchKeydown(event) {
  if (event.key === " " || event.key === "Enter") {
    event.preventDefault();
    $(this).trigger("click");
    return;
  }
  var step = 0;
  if (event.key === "ArrowRight" || event.key === "ArrowDown") step = 1;
  if (event.key === "ArrowLeft" || event.key === "ArrowUp") step = -1;
  if (!step) return;
  event.preventDefault();
  var $shown = deskUpsellShownSwatches($(this).parent());
  var index = $shown.index(this);
  var next = $shown.get((index + step + $shown.length) % $shown.length);
  if (!next) return;
  $(next).trigger("click");
  next.focus();
}

function deskUpsellSwatchesInit() {
  if (window.deskUpsellSwatchesReady) return;
  window.deskUpsellSwatchesReady = true;

  deskUpsellSwatchesSync();
  $(document).on("cart:rendered", deskUpsellSwatchesSync);
  $(document).on("keydown", DESK_UPSELL_SWATCHES, deskUpsellSwatchKeydown);
  $(document).on("click", DESK_UPSELL_SWATCHES, function () {
    setTimeout(deskUpsellSwatchesSync);
  });
}

$(document).ready(deskUpsellSwatchesInit);
